var map = {
	"./Espressokanne.svg": 394,
	"./Filterkaffeemaschine.svg": 395,
	"./Halbautomat.svg": 396,
	"./Handfilter.svg": 397,
	"./Kapselmaschine.svg": 398,
	"./Padmaschine.svg": 399,
	"./Siebstempelkanne.svg": 400,
	"./Vollautomat.svg": 401,
	"./arrow-back.svg": 402,
	"./arrow-forward.svg": 403,
	"./coldBrew.svg": 404,
	"./cup.svg": 405,
	"./touch.svg": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1149;



//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images nonrecursive \.svg$
// module id = 1149
// module chunks = 0